// 列表信息内容
import { NAME_REQUIRED, PHONE_REG } from '@/utils/validate'
import { BASE_REQUIRED } from '@/utils/validate'
// 主页按钮列表 2023.2.23 删除客服咨询菜单 { img: require('@/assets/images/icon_service@3x.png'), button: 'service', toPage: '/service', key: 6 }
export const buttonList = [
  { img: require(`@/assets/images/icon_onekey@3x.png`), button: 'repairService', key: 1, toPage: '/celerityRepairs' },
  { img: require('@/assets/images/icon_person@3x.png'), button: 'personal', toPage: '/userInfo' },
  { img: require('@/assets/images/icon_speed@3x.png'), button: 'repairSchedule', toPage: '/serviceEvaluate', key: 2 },
  { img: require('@/assets/images/icon_evalute@3x.png'), button: 'MaintenanceEvaluation', toPage: '/serviceEvaluate', key: 4 },
  { img: require('@/assets/images/icon_history@3x.png'), button: 'MaintenanceRecord', toPage: '/serviceEvaluate', key: 3 }

]
// 第二套按钮列表
export const newButtonList = [
  { img: require(`@/assets/newIcon/画板 1@3x.png`), button: 'repairService', key: 1, toPage: '/celerityRepairs' },
  { img: require('@/assets/newIcon/画板 3@3x.png'), button: 'personal', toPage: '/userInfo' },
  { img: require('@/assets/newIcon/画板 5@3x.png'), button: 'repairSchedule', toPage: '/serviceEvaluate', key: 2 },
  { img: require('@/assets/newIcon/画板 2@3x.png'), button: 'MaintenanceEvaluation', toPage: '/serviceEvaluate', key: 4 },
  { img: require('@/assets/newIcon/画板 4@3x.png'), button: 'MaintenanceRecord', toPage: '/serviceEvaluate', key: 3 },
  { img: require('@/assets/newIcon/画板 6@3x.png'), button: 'service', toPage: '/service', key: 6 }
]
// 添加设备信息列表
export const infoList = [
  // this.$route.query.deviceCode ||
  { title: 'SN', content: 'deviceCode', key: 'a', placeholder: '请输入出厂编号' },
  { title: 'hospital', content: 'hospitalName', key: 'a', placeholder: '输入出厂编号后自动录入', bind: { readonly: true, autosize: true, type: 'textarea', rows: 1 }},
  { title: 'productModel', content: 'model', key: 'a', placeholder: '输入出厂编号后自动录入', bind: { readonly: true }}
]
// 注册信息列表
export const loginFormList = [
  { title: 'ResponsibleEquipment', key: 'deviceCode', content: '16ASJFOWSJOPFFWEOFJEOIN', label: '绑定设备', bind: { required: true, rules: BASE_REQUIRED }},
  { placeholder: '输入出厂编号后自动带入', key: 'model', label: '型号', bind: { readonly: true, rules: BASE_REQUIRED }},
  { placeholder: '输入出厂编号后自动带入', key: 'hospitalName', label: 'hospital', bind: { readonly: true, rules: BASE_REQUIRED }},
  {
    placeholder: '请选择省份',
    key: 'province',
    label: '省份',
    bind: { required: true, readonly: true, rules: BASE_REQUIRED }
  },
  { placeholder: '请选择城市', key: 'city', label: '城市', bind: { required: true, readonly: true, rules: BASE_REQUIRED }},
  { placeholder: '请输入所属地址', key: 'hospitalAddress', label: 'address', bind: { required: true, rules: BASE_REQUIRED }},
  {
    placeholder: '请输入所属科室',
    key: 'hospitalDepartment',
    label: 'department',
    bind: { required: true, rules: BASE_REQUIRED }
  },
  { placeholder: '请输入所属职位', key: 'hospitalPosition', label: 'position', bind: { required: true, rules: BASE_REQUIRED }},
  { placeholder: '请输入姓名', key: 'name', label: 'name', bind: { required: true, rules: [
    ...BASE_REQUIRED,
    { pattern: NAME_REQUIRED, message: '' }
  ] }},
  {
    placeholder: 'enterNumber',
    key: 'phonenum',
    label: 'cellPhone',
    bind: {
      maxlength: 11,
      required: true,
      type: 'tel',
      rules: [
        ...BASE_REQUIRED,
        { pattern: PHONE_REG, message: '' }
      ]
    }
  }
]
// 设备信息列表
export const equipmentList = [
  { title: '出厂编号', content: '16ASJFOWSJOPF' },
  { title: '产品线', content: '16ASJFOWSJOPF' },
  { title: '型号', content: '16ASJFOWSJOPF' }
]
